import { EntitySelectEntity } from '@factorialco/f0-react/dist/experimental'

export const createLocationEntity = (
  locationId: string,
  locations: Array<{ id: string; name: string }>
): EntitySelectEntity => {
  const location = locations.find((loc) => String(loc.id) === String(locationId))
  return {
    id: String(locationId),
    name: location?.name ?? '',
  }
}

export const createLocationEntities = (
  locationIds: Array<string>,
  locations: Array<{ id: string; name: string }>
): EntitySelectEntity[] => {
  return locationIds.map((id) => createLocationEntity(id, locations))
}
